import {KEYS} from './Constants';
import {SECURE_SERVICES, secureGet, secureRemove, secureSet} from './SecureStore';

// The refresh token is long-lived credential material, so on device it lives in the OS secure
// store (iOS Keychain / Android Keystore) under its own service — never in AsyncStorage
// (core/security: tokens belong in the secure store). Web has no Keychain, so SecureStore
// falls back to storage there. Its own service keeps it separate from the email/password
// Keychain slot used for biometric unlock.
export const setRefreshToken = async token => {
  if (!token) {
    return;
  }
  await secureSet(SECURE_SERVICES.refreshToken, KEYS.refreshToken, token);
};

export const getRefreshToken = async () => {
  return secureGet(SECURE_SERVICES.refreshToken, KEYS.refreshToken);
};

export const clearRefreshToken = async () => {
  await secureRemove(SECURE_SERVICES.refreshToken, KEYS.refreshToken);
};
